import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useGbAppLogin } from '../../../hooks';
import useAmplitude from '../../../hooks/useAmplitude';
import { appsflyer, appsflyerEventName } from '../../../utils/appsflyer';
import { myLevel } from '../../../utils/utilityEtc';
import { A } from '../../common';

function JoinSuccess() {
  const { t } = useTranslation();
  const { setAmplitudeLog } = useAmplitude();
  const { gbAppLogin } = useGbAppLogin();
  const location = useLocation();

  useEffect(() => {
    const { state } = location;
    
    if (state?.mbrNm && state?.brthmt && state?.isMaketing) {
      const { mbrNm, brthmt, isMaketing } = state;
      const level = myLevel(brthmt);
      setAmplitudeLog({
        eventName: {
          name: '회원가입 완료',
          event: {
            "별명": mbrNm,
            "자가 진단 수학 수준": level,
            "마케팅수신동의여부": isMaketing,

          }
        },
        isHackleSend: true
      });

      appsflyer({
        eventName: appsflyerEventName.af_complete_registration,
        eventParams: {
          mkt_consent: isMaketing,
          af_rating_value: level
        }
      })
    }
  }, []); 

  const login = () => {
    const { state } = location;
    if (state?.email && state?.password) {
      gbAppLogin(state.password, state.email);
    }
    
  }
  return (
    <div className="layout-def log_in sign gb">
      <div className="header">
        <div className="inner">
          <div className="headerBox center">
            <div className="headerBox_head">
              <h1 className="tit">{t("MY_02_06.msg001")}</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="inner">
          <div className="center_wrap">
            <div className="logo_wrap">
              <div className="logo">
                <img src={`${process.env.PUBLIC_URL }/static/images/common/img_congrat@2x.png`} alt="" />
              </div>
            </div>
            <div className="noti_wrap">
              <div className="noti1">{t("MY_02_06.msg002")}</div>
              <div 
                className="noti2" 
                dangerouslySetInnerHTML={{ __html: t("MY_02_06.msg005", { id: location.state ? location.state.email : ''})}}
              />
                {/* <span>{location.state ? location.state : ''} test@naver.com</span> (으)로
                <br />회원가입이 완료 되었습니다.
              </div> */}
            </div>
          </div>
          <div className="bottom_wrap btn_wrap static">
            <A onClick={login} className="btn btn-blue">{t("MY_02_06.msg004")}</A>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JoinSuccess;